import styled from 'styled-components';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { media } from 'helpers/breakpoints';
import { PrivateSellerRatings as BasePrivateSellerRatings } from 'components/PageWrappers/AdDetails/components/PrivateSellerRatings/PrivateSellerRatings';
import { Link } from 'components/Toolkit/Button/Link';

const ActionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const DealerRatings = styled.div`
  margin-bottom: 0;
`;

const DealerReviewInfoTitle = styled(InfoTitle)`
  ${media.large} {
    min-height: unset;
    margin-bottom: ${({ theme }) => theme.spacing.S8};
    margin-top: ${({ theme }) => theme.spacing.S8};
  }
`;

const PrivateSellerRatings = styled(BasePrivateSellerRatings)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const MiniUserProfileAndVerifiedListContainer = styled.div<{
  googleReviews?: any;
}>`
  margin-bottom: ${({ theme, googleReviews }) =>
    googleReviews ? `0` : theme.spacing.M16};
`;

const VisitAdsLink = styled(Link)`
  text-align: center;
`;

export {
  MiniUserProfileAndVerifiedListContainer,
  ActionsList,
  DealerRatings,
  DealerReviewInfoTitle,
  PrivateSellerRatings,
  VisitAdsLink,
};
